import { useMissionNotificationRecipientsByMissionId } from '../../../../ui/features/message/hooks/useMissionNotificationRecipientsByMissionId';
import { useMissionFileCurrentDirectory } from '../../../../ui/features/mission-files/hooks/useMissionFileCurrentDirectory';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { showNotificationDialog } from '@juvare/alert-ui/ui/features/alerts';
import { useShowSelectFilesToAttachDialog } from '@juvare/alert-ui/ui/features/alerts/hooks/useShowSelectFilesToAttachDialog';
import { FormViewer } from '@juvare/common-form-ui/FormViewer';
import { showInfoSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Alert, Button, CircularProgress, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
const volunteerRecipientsOptions = ['allQualifiedVolunteers', 'upcomingShiftVolunteers', 'pastShiftVolunteers'];
export const VolunteerRecipientsModal = ({ missionId, onCloseModal }) => {
    const { t } = useMissionsTranslation();
    const { participants, isLoading } = useMissionNotificationRecipientsByMissionId({ missionId });
    const missionNotificationTypes = useSelector(getSettings).messageTypesForMissionNotificationTemplates.messageTypes;
    const [selectedVolunteerRecipients, setSelectedVolunteerRecipients] = React.useState([]);
    const { currentDirectoryId } = useMissionFileCurrentDirectory(missionId);
    const showSelectFilesToAttachDialog = useShowSelectFilesToAttachDialog();
    const openNotificationsWizard = (accountIds) => {
        showNotificationDialog({
            mode: 'notification',
            onSubmitSuccess: (_, onClose) => {
                showInfoSnackbar({ message: t('missions.messages.sent') });
                onClose();
            },
            onClose: (close) => {
                close();
                onCloseModal();
            },
            reviewFormHeader: t('missions.messages.reviewHeader'),
            wizardHeader: t('missions.messages.wizardHeader'),
            partialAlert: {
                searchData: [missionId],
                recipients: {
                    internal: {
                        includeNonMembers: false,
                        accounts: accountIds,
                        groups: [],
                        organizations: [],
                    },
                },
            },
            initialFilterData: {
                notificationType: missionNotificationTypes,
            },
            additionalRichTextEditorMenuItems: currentDirectoryId
                ? [
                    {
                        key: 'addAttachmentButton',
                        label: t('missions.messages.selectInMissionFiles'),
                        onClick: (params) => showSelectFilesToAttachDialog(Object.assign(Object.assign({}, params), { rootDirectoryId: currentDirectoryId })),
                    },
                ]
                : undefined,
        });
    };
    const handleVolunteerRecipientsFormSubmit = () => {
        const accountIds = new Set();
        selectedVolunteerRecipients === null || selectedVolunteerRecipients === void 0 ? void 0 : selectedVolunteerRecipients.forEach((volunteerRecipient) => {
            participants === null || participants === void 0 ? void 0 : participants[volunteerRecipient].forEach((id) => accountIds.add(id));
        });
        openNotificationsWizard(Array.from(accountIds));
    };
    const volunteerRecipientsForm = {
        type: 'form',
        children: [
            {
                type: 'form.checkboxList',
                key: 'volunteerRecipients',
                values: volunteerRecipientsOptions.map((value) => ({
                    value,
                    label: t(`missions.messages.${value}`),
                })),
            },
        ],
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('missions.messages.modalTitle')),
        React.createElement(DialogContent, null,
            React.createElement(FormViewer, { config: volunteerRecipientsForm, onDataChange: ({ data }) => {
                    setSelectedVolunteerRecipients(data.volunteerRecipients);
                } }),
            React.createElement(Alert, { severity: 'info', sx: { mt: 2 } }, t('missions.messages.modalAlert'))),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: () => onCloseModal(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { disabled: isLoading, onClick: handleVolunteerRecipientsFormSubmit, "data-test": 'send-button' }, isLoading ? React.createElement(CircularProgress, { size: '1rem' }) : t('common.send')))));
};
